import { Component, computed, input } from '@angular/core';
import { SkeletonModule } from '@openng/optimus-ui/skeleton';

@Component({
    selector: 'cor-skeleton-loader',
    template: `
        @for (item of totalSkeletons(); track $index) {
            <p-skeleton
                [height]="height()"
                [width]="width()"
                [borderRadius]="borderRadius()"
                [style]="{
                    margin: margin(),
                }"
            />
        }
    `,
    imports: [SkeletonModule],
})
export class SkeletonLoaderComponent {
    readonly width = input('100%');
    readonly height = input('70px');
    readonly count = input(1);
    readonly borderRadius = input('3px');
    readonly margin = input('0px');

    protected readonly totalSkeletons = computed(() => Array(this.count()).fill(0));
}
